import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import Alert from "react-s-alert";
import qs from "qs";

class ModalPesanStore extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pesan : '',
            dataPesan:[],
            isLoading : false
        }

        this.toggleModalPesan = this.toggleModalPesan.bind(this)
        this.handleSubmitPesan = this.handleSubmitPesan.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    toggleModalPesan() {
        this.props.toggleModalPesan()
    }

    handleSubmitPesan() {
        this.setState({ isLoading: true })

        const params = qs.stringify({
            data_id:'0',
            pesanId:this.state.dataPesan ? this.state.dataPesan.id : '0',
            user_id:localStorage.SISMART_USER_ID,
            pesan:this.state.pesan,
            menu:'exam',
            type:'block',
            icon:'fa-danger',
        })

        const url ='/pesan/add';

        axios
            .post(url, params)
            .then(response => {
                const result = response.data;

                if (result.success) {
                    Alert.success(result.message,{
                        position: 'bottom-right'
                    });
                    this.setState({
                        isLoading: false
                    },()=>{
                        this.toggleModalPesan()
                    })
                } else {
                    Alert.error(result.message,{
                        position: 'bottom-right'
                    });

                    this.setState({
                        isLoading: false
                    },()=>{
                        this.toggleModalPesan()
                    })


                }
            })
            .catch(error => {
                console.log("ERROR", error);
                Alert.error("Gagal terhubung ke server!",{
                    position: 'bottom-right'
                });
                this.setState({ isLoading: false },()=>{
                    this.toggleModalPesan()
                });
            });
        this.setState({ isLoading: false });
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    loadDataPesan() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            menu: 'exam',
            type : 'block'
        })

        axios({
            method: 'post',
            url: '/pesan/detail?' + params
        })
            .then((response) => {

                const result = response.data

                if (result.success === true) {
                    this.setState({
                        dataPesan : result.data,
                        pesan : result.data ? result.data.text : 'Ujian online tidak bisa dimulai, mohon untuk menyelesaikan administrasi terlebih dahulu',
                        isLoading  : false
                    })
                }
                else {
                    Alert.error(result.message,{
                        position: 'bottom-right'
                    })
                    this.setState({
                        dataPesan : [],
                        pesan : 'Ujian online tidak bisa dimulai, mohon untuk menyelesaikan administrasi terlebih dahulu',
                        isLoading  : false
                    })
                }
            })
            .catch((error) => {
                console.log(error)
                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!",{
                    position: 'bottom-right'
                })
            })
    }

    componentDidMount() {
        this.loadDataPesan();
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.toggleModalPesan} className="modal-primary">
                <ModalHeader toggle={this.toggleModalPesan}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    <div>
                        <div className="card">
                            <div className="card-header">
                                Pesan Pemblokiran Ujian
                            </div>
                            <div className="card-body">
                                <textarea
                                    name="pesan"
                                    className="form-control"
                                    placeholder="Pesan Pemblokiran"
                                    onChange={this.handleChange}
                                    value={this.state.pesan}
                                    rows="5"
                                />
                            </div>
                            <div className="card-footer">
                                <div style={{float:'right'}}>
                                    <span style={{ fontSize:'10px', color:'red',fontWeight:'bold' }}>*Pesan ini akan ditampilkan di ujian siswa yg di blokir akses ujiannya.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleSubmitPesan}>{this.state.isLoading ? 'Loading...' : this.props.modalSubmitText}</Button>{' '}
                    <Button color="secondary" onClick={this.toggleModalPesan}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

ModalPesanStore.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModalPesan: PropTypes.func.isRequired,
    userId: PropTypes.func.userId
}

export default ModalPesanStore


// WEBPACK FOOTER //
// ./src/components/ModalPesanStore.js